import notFoundImage from '@/assets/illustrations/not-found.png'
import emptyMascot from '@/assets/images/follow-empty-mascot.png'
import appBrandLogo from '@/assets/images/app-brand-logo.png'
import emptyImage from '@/assets/images/profile-state-empty.png'
import offlineImage from '@/assets/images/profile-state-offline.png'
import loginPromptWave from '@/assets/illustrations/login-prompt-wave.webp'

export const stateImages = {
  empty: emptyImage,
  /**
   * @deprecated 网络错误状态已统一改用内联 SVG。
   * 保留此字段仅避免外部引用突然断裂；UI 不应再使用它。
   */
  offline: offlineImage,
  emptyMascot,
  notFound: notFoundImage,
  appBrandLogo,
  loginPromptWave,
} as const

export function preloadStateImages(): void {
  if (typeof window === 'undefined') {
    return
  }

  const preloadableSources = [
    stateImages.empty,
    stateImages.emptyMascot,
    stateImages.notFound,
    stateImages.appBrandLogo,
    stateImages.loginPromptWave,
  ]
  const trigger = () => {
    preloadableSources.forEach((src) => {
      const image = new window.Image()

      image.decoding = 'async'
      image.fetchPriority = 'low'
      image.src = src
    })
  }

  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(trigger, { timeout: 3000 })
    return
  }

  window.setTimeout(trigger, 1500)
}
